const Scripts = (): JSX.Element | null => {
  return <></>;
};

export default Scripts;
